import React, {useEffect, useState, useMemo, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Icon from 'react-web-vector-icons';
import searchIcon from '../../assets/search-glass.png';
import PageBase from "../../components/PageBase";
import Datatable from "../../components/Datatable";
import * as opportunityActions from "../../redux/Opportunity/actions";
import Filters from "../../components/Filters";
import availableFilters from './availableFilters.js';
import LoadingPanel from "../../components/LoadingPanel";
import columns from './column.js';
import Button from "../../components/Button";
import usePersistentFilters from '../../hooks/usePersistentFilters';
import useColumnFilters from '../../hooks/useColumnFilters.js';
import './Opportunities.scss';
import PopupWin from "../../components/PopupWin";
import PopupButton from "../../components/PopupButton";
import EditOpportunity from "./EditOpportunity";
import { getDisplayFields, getDefaultFields } from '../../utils/fields/opportunities.js';
import ListManager from '../../components/ListManager';
import constants  from '../../utils/constants.js';
import {createColumnConfigs} from '../../utils/fieldUtils.js';

const Opportunities = props => {
	const [newOpportunity, setNewOpportunity] = useState(null);
	const [loading, setLoading] = useState(true);
	const [filterResetKey, setFilterResetKey] = useState(0);
	const [listColumns, setListColumns] = useState([]);
	const editOpportunityRef = useRef(null);
	const entityType = `${constants.DISPLAY_ENTITIES.OPPORTUNITIES}`;
		const fieldsToUse = useMemo(() => {
		return createColumnConfigs(getDisplayFields(listColumns.length === 0,listColumns))
		}, [listColumns]);

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const opportunities = useSelector(state => state.opportunity).opportunities;
	const lastUpdated = useSelector(state => state.opportunity).lastUpdated;

	const {
		search,
		setSearch,
		selectedFilters,
		setSelectedFilters,
		clearFilters: clearPersistentFilters
	} = usePersistentFilters('opportunities', '', []);

	const searchedData = useMemo(() => {
	if (!opportunities) return [];
	if (!search) return opportunities;
	const lowerSearch = search.toLowerCase();
	return opportunities.filter(f => f.Name.toLowerCase().includes(lowerSearch));
	}, [opportunities, search]);


		const {
			filters,
			sortBy,
			sortOrder,
			filteredData,
			handleFilterChange,
			updateData,
			uniqueValuesByColumn,
			filterOrder
		} = useColumnFilters({
			data: loading ? [] : searchedData,
			columns: fieldsToUse,
			storageKey: `opportunities`,
			initialState: {}
		});

	const newOpportunityFooter = useMemo(() => (
		<PopupButton
			variant="primary"
			onClick={() => editOpportunityRef.current?.save()}
		>
			Create
		</PopupButton>
	), []);
		
	useEffect(() => {
		if(selectedFilters.length > 0) {
			return;
		}
		const load = async () => {
			await dispatch(opportunityActions.loadOpportunities([]));
			setLoading(false);
		};
		load();
	}, []);
		useEffect(() => {
		updateData(opportunities);
	}, [opportunities]);

	useEffect(() => {
		  if (selectedFilters.length === 0) return;
		const load = async () => {
			setLoading(true);
			await dispatch(opportunityActions.loadOpportunities(selectedFilters));
			setLoading(false);
		};
		load();
	}, [selectedFilters]);

	if(loading || opportunities == null) {
		return (
			<PageBase title="Opportunities" removeMargins>
				<LoadingPanel />
			</PageBase>
		)
	}

	const onRowClick = async (row, index) => {
		console.log(index, row.Id);
		navigate(`/opportunity/${row.Id}`);
	};

	const updateFilter = (value) => {
		setSearch(value.toLowerCase());
	};


	const addFilter = filter => {
		const index = selectedFilters.findIndex(f => f.name === filter.name);

		if(index < 0) {
			setSelectedFilters([...selectedFilters, filter]);
		}
		else {
			const updated = [...selectedFilters];
			updated[index] = filter;
			setSelectedFilters(updated);
		}
	};
	const forceReload = async () => {
			 dispatch(opportunityActions.loadOpportunities(selectedFilters,true));
		};
	const onOpportunitySaved = async () => {
		setNewOpportunity(null);
		setLoading(true);
		// await dispatch(opportunityActions.loadOpportunityById(params.id))
		setLoading(false);
	};

	const removeFilter = (filterToRemove) => {
		const filters = selectedFilters.filter(f => f.name !== filterToRemove.name);
		setSelectedFilters(filters);
	};

	const onClearFilters = () => {
		clearPersistentFilters();
	};

console.log("availableFilters",availableFilters);
	return (
		<PageBase title="Opportunities" removeMargins>
			<div className="opps-header">

				<PopupWin
					closeOnEscape={false}
					closeOnDocumentClick={false}
					visible={newOpportunity != null}
					onClose={() => setNewOpportunity(null)}
					title="New Opportunity"
					titleStyle={{fontSize: '18px', margin: '0 0 25px 0'}}
					contentStyle={{width: '100%', height: '90%', padding: 0}}
					popupStyle={{width: '90%', maxWidth: '1600px', height: '84%', maxHeight: '800px', overflow: 'none'}}
					footerStyle={{borderTop: '1px solid #D3E1ED'}}
					footer={newOpportunityFooter}>
					{ newOpportunity && <EditOpportunity
						ref={editOpportunityRef}
						editMode={false}
						opportunity={newOpportunity}
						onClose={onOpportunitySaved}
						forceReload={forceReload}
					/> }
				</PopupWin>

				<div className="opps-search-box">
					<img src={searchIcon} style={{padding: '0 10px'}} />
					<input className="opps-search-input" type="text" value={search} onChange={e => updateFilter(e.target.value)} placeholder="Search Opportunities..." />
				</div>
				<Filters availableFilters={availableFilters()} clearFilters={onClearFilters} selectedFilters={selectedFilters} onAddFilter={addFilter} onRemoveFilter={removeFilter} />

				<div className="opps-header-buttons">
					<ListManager
						entityType={entityType}
						onColumnsChange={setListColumns}
						displayFields={getDisplayFields()}
						defaultFields={getDisplayFields(true).map(f => f.field)}
					/>
					
					<Button onClick={() => setNewOpportunity({})} type="blue" center>
						<Icon name="plus" font="AntDesign" size={16} color="white" /> Add Opportunity
					</Button>
				</div>

			</div>

			{selectedFilters.length > 0 && (
				<div style={{margin: '0 30px'}}>
					<p style={{ color: '#062229', fontWeight: 700, fontSize: 14 }}>Found {filteredData?.length || 0} Opportunities</p>
				</div>
			)}


			<div style={{margin: '0 30px'}}>
				<Datatable 
					gridHeight="calc(100vh - 185px)"
					columns={fieldsToUse}
					data={filteredData}
					key={filterResetKey}
					//onSort={updateSort}
					sortBy={sortBy}
					sortOrder={sortOrder}
					onRowClick={onRowClick}
					filters={filters}
					onFilterChange={handleFilterChange}
					filterOrder={filterOrder}
					uniqueValuesByColumn={uniqueValuesByColumn}
					allData={opportunities}
				/>
			</div>
		</PageBase>
	)
};

export default Opportunities;
